import { Model } from '@/models/Model';
export class Level extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Level';
        this.$endpoint = '/levels';
        this.$fillable = ['name', 'value', 'sequence', 'is_mandatory', 'users'];
    }
    getFilterLabel() {
        return this.name || '';
    }
}
